// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 25","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"font-background"},"children":[{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 21.3135H20V22.3135H4V21.3135Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12.414 1.41406L20.8993 9.89934L12.414 18.3846L3.92871 9.89934L12.414 1.41406Z"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M12.414 1.41406L20.8993 9.89934L12.414 18.3846L3.92871 9.89934L12.414 1.41406Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M6.75725 12.7275L9.58568 15.556L8.17147 16.9702H5.34304L3.92883 15.556L6.75725 12.7275Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const FontBackgroundIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'font-background',
    ref,
    icon: element,
  },
));

FontBackgroundIcon.displayName = 'FontBackgroundIcon';

export default FontBackgroundIcon;
